import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from './lib/utils';
const VARIANT_GRADIENTS = {
    // 110deg diagonal, 3-stop gradient: dark base → bright highlight at
    // mid-stop → dark base. The 200% background-size + the shimmer2
    // keyframe slides this leftward across the button surface.
    primary: 'bg-[linear-gradient(110deg,#3D0066,45%,#A847E8,55%,#3D0066)]',
    success: 'bg-[linear-gradient(110deg,#003A3B,45%,#5FE8EC,55%,#003A3B)]',
};
const VARIANT_BORDERS = {
    primary: 'border-[#8200DB]/40',
    success: 'border-[#0BB5BA]/40',
};
const VARIANT_FOCUS_RINGS = {
    primary: 'focus-visible:ring-[#A847E8]',
    success: 'focus-visible:ring-[#5FE8EC]',
};
export function ShimmerButton({ children = 'Shimmer', className, variant = 'primary', ...props }) {
    return (_jsx("button", { className: cn(
        // base layout
        'inline-flex h-12 items-center justify-center rounded-md border px-6 font-medium transition-colors', 
        // shimmer animation + 200% bg-size so the gradient slides
        'animate-shimmer2 bg-[length:200%_100%]', 
        // accessibility
        'focus:outline-none focus-visible:ring-2 focus:ring-offset-2 focus:ring-offset-black', 
        // disabled state (matches the rest of the @dymaxion/ui buttons)
        'disabled:pointer-events-none disabled:opacity-50', 
        // variant — gradient + border + focus ring
        VARIANT_GRADIENTS[variant], VARIANT_BORDERS[variant], VARIANT_FOCUS_RINGS[variant], 
        // text colour — bright white sits well over both purple and teal
        // gradients while the highlight stop sweeps through
        'text-white', className), ...props, children: children }));
}
//# sourceMappingURL=shimmer-button.js.map